import {inject, Injectable} from '@angular/core';
import {DataEntity} from 'octopus-connect';
import {SyncRules} from '@modules/graph-humanum/core/model/rules';
import {GraphHumanumRoutes} from '@modules/graph-humanum/core/graph-humanum.routes';
import {FuseNavigationItem} from 'fuse-core/types';
import {DynamicNavigationService} from '../../../../navigation/dynamic-navigation.service';
import {CommunicationCenterService} from '@modules/communication-center';
import {GraphHumanumAuthorizationService} from '@modules/graph-humanum/core/services/graph-humanum-authorization.service';
import {AuthorizationService} from '@modules/authorization';

@Injectable({
  providedIn: 'root'
})
export class GraphHumanumInitService {

    private static isMenuSet = false;
    private dynamicNavigation = inject(DynamicNavigationService);
    private communicationCenter = inject(CommunicationCenterService);
    private graphHumanumAuthorizationService = inject(GraphHumanumAuthorizationService);
    private authorizationService = inject(AuthorizationService);


    constructor() { }

    initialize(){
        this.graphHumanumAuthorizationService.activeRulesOnStartup();

        this.communicationCenter
            .getRoom('authentication')
            .getSubject('userData')
            .subscribe((data: DataEntity) => {
                if (data) {
                    this.postAuthentication(); // Call the moved method
                } else {
                    this.postLogout(); // Call the moved method
                }
            });
    }

    private postAuthentication(): void {
        if (!GraphHumanumInitService.isMenuSet && this.authorizationService.currentUserCan<boolean>(SyncRules.seeGraphsLinksInMenu)) {
            this.dynamicNavigation.registerModuleMenu('level0', {
                'id': 'graph-humanum',
                'title': 'graph-humanum',
                'translate': 'graph_humanum.menu_link',
                'type': 'item',
                'icon': 'analytics',
                'url': '/graph-humanum/multi',
            });

            Object.keys(GraphHumanumRoutes)
                .map(route => GraphHumanumRoutes[route].toLowerCase())
                .map(route => ({
                    'id': `graph-humanum-single-${route}`,
                    'title': `graph-humanum-single-${route}`,
                    'translate': `graph_humanum.single_${route}_link`,
                    'type': `item`,
                    'icon': `analytics`,
                    'url': `/graph-humanum/single/${route}`,
                }) satisfies FuseNavigationItem).forEach(menuLink => {
                this.dynamicNavigation.registerModuleMenu('level0', menuLink);
            });

            GraphHumanumInitService.isMenuSet = true;
        }
    }

    private postLogout(): void {
        GraphHumanumInitService.isMenuSet = false;
        this.dynamicNavigation.clearMenuItem('level0', 'graph-humanum');
        Object.keys(GraphHumanumRoutes)
            .map(route => GraphHumanumRoutes[route].toLowerCase())
            .map(route => `graph-humanum-single-${route}`)
            .forEach(menuLink => {
                this.dynamicNavigation.clearMenuItem('level0', menuLink);
            });
    }
}
